import { useMemberAsMemberNew } from "@gymflow/api";
import { usePortalRoutes } from "apps/portal/src/hooks";
import { RouteFeature } from "apps/portal/src/routes";

import useGymflowModels from "../../../store";
import { Button } from "../../atoms";

export type HostedPagesProfileAvatarProps = {};

const HostedPagesProfileAvatar = ({}: HostedPagesProfileAvatarProps) => {
  const { api } = useGymflowModels();
  const { createSiteOrEmbedLink } = usePortalRoutes();
  const { data: userMember } = useMemberAsMemberNew({ api });

  const initials = (
    (userMember?.firstName[0] ?? "") + (userMember?.lastName[0] ?? "")
  ).toUpperCase();

  return (
    <Button
      link={createSiteOrEmbedLink(RouteFeature.SiteProfile)}
      intent="transparent"
      className="!border-secondary-500 flex size-12 items-center justify-center overflow-hidden !rounded-full border-2 border-solid p-0"
    >
      {userMember?.picture && (
        <img
          src={userMember?.picture}
          alt="User's Profile"
          className="flex aspect-square size-full object-cover"
        />
      )}
      {!userMember?.picture && (
        <div className="dark:text-gray-0 flex text-center text-lg font-semibold text-gray-950">
          {initials}
        </div>
      )}
    </Button>
  );
};

export default HostedPagesProfileAvatar;
